export interface JwtPayload {
  data: {
    _id: string;
    email: string;
    name: string;
    isAdmin?: boolean;
  };
  iat: number;
  exp: number;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const parsedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = JSON.parse(atob(parsedPayload));

    return decoded;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, bufferSeconds = 300): boolean {
  try {
    const payload = decodeJwt(token);
    if (!payload || !payload.exp) return true;

    const currentTimeInSeconds = Date.now() / 1000;
    return payload.exp < currentTimeInSeconds + bufferSeconds;
  } catch {
    return true;
  }
}

export function getTokenExpiry(token: string): Date | null {
  try {
    const payload = decodeJwt(token);
    if (!payload || !payload.exp) return null;

    return new Date(payload.exp * 1000);
  } catch {
    return null;
  }
}

export function isAdminToken(token: string): boolean {
  try {
    const payload = decodeJwt(token);
    return payload?.data?.isAdmin === true;
  } catch {
    return false;
  }
}
